import React, { useState } from "react";
import {
  FormFeedback,
  Input,
  InputGroup,
  InputGroupText,
  Label,
} from "reactstrap";

const BaseInput = ({
  autoComplete,
  className,
  defaultValue,
  disabled,
  error,
  fullWidth,
  name,
  onChange,
  placeholder,
  label,
  readOnly,
  required,
  type,
  value,
  tooltip,
  tooltipIcon,
  tooltipIconColor,
  tooltipText,
  accept,
  append,
  handleBlur,
  prepend,
  touched,
  maxLength,
  rows,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleKeyInput = (event) => {
    const allowedKeys = [
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
      "Tab",
      ".",
    ];

    if (type !== "number" && type !== "email") return;
    if (event.code === "Space") event.preventDefault();

    if (
      type === "number" &&
      !allowedKeys.includes(event.key) &&
      (!/^\d$/.test(event.key) ||
        (maxLength && value?.toString().length >= maxLength))
    ) {
      event.preventDefault();
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className={`text-start ${fullWidth ? "w-100" : ""}`}>
      {label && (
        <>
          <Label for={name}>
            {label}
            {required && <span className="text-danger">*</span>}
          </Label>
          {tooltip && (
            <i
              className={`mdi mdi-${tooltipIcon} ms-1 text-${tooltipIconColor} cursor-pointer tooltip-container`}
            >
              <span className="tooltip-text bottom-5 mt-4">{tooltipText}</span>
            </i>
          )}
        </>
      )}
      <InputGroup>
        {prepend && <InputGroupText>{prepend}</InputGroupText>}
        <Input
          id={name}
          name={name}
          className={`${className} shadow-none`}
          autoComplete={autoComplete}
          defaultValue={defaultValue}
          disabled={disabled}
          invalid={!!(error && touched)}
          placeholder={placeholder}
          accept={accept}
          onKeyDown={handleKeyInput}
          readOnly={readOnly}
          onBlur={handleBlur}
          maxLength={type !== "number" ? maxLength : undefined}
          type={
            type === "password" ? (showPassword ? "text" : "password") : type
          }
          value={value}
          onChange={onChange}
          rows={rows}
        />
        {append && (
          <InputGroupText>
            <span className="input-group-text">{append}</span>
          </InputGroupText>
        )}
        {type === "password" && (
          <InputGroupText
            onClick={handleClickShowPassword}
            style={{ cursor: "pointer" }}
            title={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? (
              <i className="ri-eye-fill text-muted"></i>
            ) : (
              <i className="ri-eye-off-fill text-muted"></i>
            )}
          </InputGroupText>
        )}
        {error && touched && <FormFeedback>{error}</FormFeedback>}
      </InputGroup>
    </div>
  );
};

export default BaseInput;
